<template>
    <div>
        <tab name="8"></tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sort" placeholder="请选择" size="small">
                        <el-option label="优先展示最新日期的" :value="0"></el-option>
                        <el-option label="优先展示销售额最多的" :value="1"></el-option>
                        <el-option label="优先展示商品数最多的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="timeStr" label="日期" :min-width="150"></el-table-column>
                <el-table-column prop="goodsId" label="商品ID" :min-width="150"></el-table-column>
                <el-table-column prop="goodsName" label="商品名称" :min-width="150"></el-table-column>
                <el-table-column prop="amount" label="销售额" :min-width="150"></el-table-column>
                <el-table-column prop="goodsNum" label="商品数" :min-width="150"></el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="pageSizeChange"
                @current-change="pageNoChange"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import Tab from './../../components/tab';

export default {
    components:{Tab},
    data(){
        this.defaultParams = {
            sort: 0,
            pageNo: 1,
            pageSize: this.$pageSizes[0]
        };

        return{
            data: null,
            dataList: null,
            params: {...this.defaultParams},
            listLoading: false
        }
    },
    created() {
        this.getDataList();
    },
    methods:{
        //获取列表
        async getDataList() {
            const {goodsId, timeStart, timeEnd} = this.$route.query;
            const {...params} = this.params;

            this.listLoading = true;

            const res = await this.$request({
                url: '/sales/goods/goods_detail',
                method: 'post',
                data: {...params, goodsId, timeStart, timeEnd}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.listLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.data = result;
            this.dataList = result.result || [];
        },
         //选择pageSize
        pageSizeChange() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        pageNoChange() {
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {...this.defaultParams};
            this.getDataList();
        }
    }
}
</script>